export default __webpack_public_path__ + "static/Byron-22b608f7bdbb4d404a37ae0660c4afdc.svg";